module.exports = __webpack_public_path__ + "img/Lauffer.7ef443d9.jpg";